import { Vector2 } from "three"

const SEPARATOR = '-'
export const coordsToKey = (c: Vector2): string => `${c.x}${SEPARATOR}${c.y}`
export const keyToCoord = (key: string): Vector2 => (new Vector2(
  Number(key.split(SEPARATOR)[0]),
  Number(key.split(SEPARATOR)[1])
))
